import { useCallback } from 'react';
import LoadingIndicatorFull from '../../../components/LoadingIndicatorFull';
import Modal from '../../../components/Modal';
import ShowDelayed from '../../../components/ShowDelayed';
import { withPageData } from '../../../hoc/withPageData';
import { compileAngular, getAngularService, getAngularServiceWeak } from '../../../services/AngularService';

type Props = {
    isOpen: boolean;
    onClose(): void;
    onAfterClose(): void;
    objectiveId: string;
    cycleId: string;
    onRemove(): void;
};

type InnerProps = Props & {
    objective: any;
};

export default withPageData<{ objective: any; _cycle: unknown; _users: unknown; _component: unknown }, Props>({
    resolve: {
        objective: async ({ objectiveId, cycleId }) => {
            const ObjectiveLookupService = await getAngularService(
                () =>
                    import(
                        /* webpackChunkName: 'ObjectiveModal' */ '../../../../screens/objective/services/objective-lookup-service'
                    ),
                'ObjectiveLookupService'
            );
            return ObjectiveLookupService.fetchById(objectiveId, cycleId);
        },
        _cycle: async ({ cycleId }) => {
            const ObjectiveCycleLookupService = await getAngularService(
                () =>
                    import(
                        /* webpackChunkName: 'ObjectiveModal' */ '../../../../screens/objective/services/objective-cycle-lookup-service'
                    ),
                'ObjectiveCycleLookupService'
            );
            return ObjectiveCycleLookupService.fetchById(cycleId);
        },
        _users: async () => {
            const UserService = await getAngularService(
                () => import(/* webpackChunkName: 'ObjectiveModal' */ '../../../../screens/users/services/user'),
                'UserService'
            );
            return UserService.fetchUsers();
        },
        _component: () =>
            getAngularService(
                () =>
                    import(
                        /* webpackChunkName: 'ObjectiveModal' */ '../../../../screens/objective/components/objective'
                    )
            ),
    },
    pendingComponent: () => (
        <ShowDelayed>
            <LoadingIndicatorFull />
        </ShowDelayed>
    ),
    shouldRefetch: (prevProps, props) =>
        prevProps.cycleId !== props.cycleId || prevProps.objectiveId !== props.objectiveId,
})(ObjectiveModal);

function ObjectiveModal({ objective, isOpen, onClose, onAfterClose, onRemove }: InnerProps) {
    const handleOnAfterClose = useCallback(() => {
        onAfterClose();
        getAngularServiceWeak('ObjectiveScrollToService')?.highlightTarget(objective.id, () => {}, {
            highlightClass: 'just-closed',
        });
    }, [objective.id, onAfterClose]);
    return (
        <Modal isOpen={isOpen} onClose={onClose} onAfterClose={handleOnAfterClose} width={960} topAligned={true}>
            {compileAngular(
                `<objective
                    objective="$ctrl.objective"
                    on-remove="$ctrl.onRemove">
                </objective>`,
                { objective, onRemove }
            )}
        </Modal>
    );
}
